import { publicSeatName, type PublicSeat } from "./public-presentation";
export type ClueEvidence = {
  playerId: string;
  name: string;
  seat: number;
  text: string | null;
  pass: number;
};
export function impostorEvidence(
  players: ReadonlyArray<PublicSeat>,
  clues: ReadonlyArray<{ playerId: string; text: string; pass: number }>,
  pass: number,
): ClueEvidence[] {
  return players.map((p) => ({
    playerId: p.id,
    name: publicSeatName(players, p.id),
    seat: p.seat,
    text:
      clues.find((c) => c.playerId === p.id && (c.pass ?? 1) === pass)?.text ??
      null,
    pass,
  }));
}
